<template>
  <div>
    <div class="box" style="margin: 20px auto;">
		<div class="btns cursor" @click="jumpCardList">{{$t("My Card")}} >></div>
		<!-- 卡片类型切换 -->
		<div class="card-switch">
		  <span
		    :class="['switch-item', cardType === 'gold' ? 'active' : '']"
		    @click="switchCard('gold')"
		  >
		    Gold Card
		  </span>
		  <span class="divider">|</span>
		  <span
		    :class="['switch-item', cardType === 'gift' ? 'active' : '']"
		    @click="switchCard('gift')"
		  >
		    Gift Card
		  </span>
		</div>
			<div class="box_list" v-for="(item,index) in giftCardList" :key="index" :class="(index+1)%4 === 0?'nomaagrinrt':''">
				<img class="box_list_img" :src="item.image" :class="item.is_buy==1 ? '' : 'filter'"/>
				<div class="box_list_txt ellipsis">{{item.name}}</div>
				<div class="box_list_foot">
					<div class="list_foot_lf">${{item.usd}}</div>
					<div class="list_foot_rt cursor" @click="goDetail(item)">{{$t('Buy now')}}</div>
					<!-- <div class="list_foot_rt cursor" v-if="cardType == 'gift'" @click="goDetail(item)">{{$t('Buy now')}}</div>
              		<div class="list_foot_rt cursor" v-else style="background-color: #ccc;">Coming soon</div> -->
				</div>
			</div>
	  </div>
    <empty-record v-if='giftCardList.length <= 0 && !isMore'></empty-record>
  </div>

</template>

<script>
import { Toast,Indicator } from 'mint-ui'
import HomeCommonSearch from '../common/HomeCommonSearch'
import EmptyRecord from '../../EmptyRecord'
import { getGiftCardList, getGoldCardList } from '../../../api/giftcard'
export default {
  name: 'GiftCardList',
  components: {
    HomeCommonSearch,
    EmptyRecord
  },
  data() {
    return {
      loading: false, // 是否加载更多
      isMore: true,// 是否有更多
      params:{page: 0,},
      giftCardList: [], // 商品列表
      cardType: 'gold' // 卡片类型：gold 或 gift
    }
  },
  created() {

  },
  mounted(){
    this.getDataList()
  },
  methods:{
    switchCard(type) {
      if (this.cardType === type) return
      this.cardType = type
      this.giftCardList = []

      Indicator.open()
      const api = type === 'gold' ? getGoldCardList : getGiftCardList

      api().then(res => {
        Indicator.close()
        this.giftCardList = res.result.list || res.result
      })
    },
    goDetail (item) {
		if(item.is_buy == 2){
		this.timer = setTimeout(() => {
			this.$router.push({ 'name': 'Shares'})
		}, 1500);
			return Toast(this.$t("is not share"));//您还未完成分享任务
		}

		if(item.is_buy == 3){
			return Toast(this.$t("is buied"));//您今天已经购买过了
		}
		this.$router.push({ 'name': 'GiftCardDetails', 'query': { 'data': JSON.stringify(item) } })
    },
    getDataList(){
      Indicator.open()
      getGoldCardList().then(res => {
        Indicator.close()
        this.giftCardList = res.result.list || res.result
      })
    },
	jumpCardList(){
		this.$router.push({'name': 'MyCardList'})
	}
  }
}
</script>

<style scoped lang="scss">
.filter{filter: grayscale(100%);}
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.cursor:hover{
  cursor: pointer;
}

			.ellipsis {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}


			.box {
				width: 1200px;
				margin: 20px auto;
				background: #fff;
				border-radius: 4px;
				padding:60px 25px 25px 25px;
				display: flex;
				flex-wrap: wrap;
				box-sizing: border-box;
				position: relative;
		.btns{

			height: 36px;
			line-height: 36px;
			background: #EF4618;
			border-radius: 4px;
			text-align: center;
			color: #fff;
			font-size: 14px;
			padding: 0 10px;
			position: absolute;
			top: 10px;
			right: 10px;
		}

				.box_list {
          &.nomaagrinrt {
            margin-right: 0;
          }
					width: 280px;
					height: 260px;
					background: #FFFFFF;
					box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.06);
					border-radius: 12px 12px 12px 12px;
					padding: 20px;
					margin-right: 10px;
					margin-bottom: 20px;
          overflow: hidden;
					.box_list_img {
						display: block;
						width: 236px;
						height: 148px;
						object-fit: contain;
					}

					.box_list_txt {
						font-size: 16px;
						color: #000000;
						line-height: 22px;
            margin-top: 14px;
					}

					.box_list_foot {
						margin-top: 14px;
						;
						display: flex;
						justify-content: space-between;

						.list_foot_lf {
							font-size: 20px;
							color: #EF4618;
							line-height: 22px;
						}
						.list_foot_rt {
							padding: 5px 10px;
							background: #EF4618;
							border-radius: 4px 4px 4px 4px;
							font-size: 14px;
							color: #FFFFFF;
							text-align: center;
						}
					}
				}
			}

.card-switch {
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #999;

  .switch-item {
    cursor: pointer;
    padding: 0 8px;
    transition: all 0.3s;
  }

  .active {
    color: #EF4618;
    font-weight: bold;
    text-decoration: underline;
  }

  .divider {
    margin: 0 5px;
  }
}
</style>
